/**
 * Processing → Reports: the list of the Processing reports this login holds (user, 2026-10-28: no
 * tabs). Each report is its own page, /processing/reports/$key; a bookmarked `?tab=` link opens it.
 */
import { reportPermissionsOf } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { ProcessingReportsIndexPage } from "@/features/processing/reports/processing-reports-index";

const search = z
  .object({
    tab: z
      .enum([
        "processing",
        "drying",
        "priming",
        "color-sort",
        "consolidated",
        "organiser-status",
        "personnel-status",
        "qc-ageing",
      ])
      .optional()
      .catch(undefined),
  })
  // The old tabs' filters ride along to the report's own page.
  .passthrough();

export const Route = createFileRoute("/_app/processing/reports/")({
  validateSearch: search,
  beforeLoad: ({ search: s }) => {
    // Any Processing Report's own code opens the list (user, 2026-10-16).
    const { can } = useAuth.getState();
    if (!reportPermissionsOf("processing").some((c) => can(c)))
      throw redirect({ to: "/" });
    const { tab, ...rest } = s;
    if (tab === "qc-ageing") throw redirect({ to: "/quality/qc-ageing" });
    if (tab)
      throw redirect({
        to: "/processing/reports/$key",
        params: { key: tab },
        search: rest,
        replace: true,
      });
  },
  component: ProcessingReportsIndexPage,
});
